import React from 'react';
import { IconProps } from '@/models/IconProps';

const Forward10Icon: React.FC<IconProps> = ({ height = '25', width = '25', strokeColor = '#1F2126' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={'0 0 ' + width + ' ' + height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7148 0C6.09938 0 0.714844 5.38453 0.714844 12C0.714844 18.6155 6.09938 24 12.7148 24C19.3303 24 24.7148 18.6155 24.7148 12C24.7167 11.8675 24.6922 11.7359 24.6428 11.613C24.5934 11.49 24.52 11.3781 24.427 11.2837C24.334 11.1893 24.2231 11.1144 24.1008 11.0632C23.9786 11.0121 23.8474 10.9858 23.7148 10.9858C23.5823 10.9858 23.4511 11.0121 23.3289 11.0632C23.2066 11.1144 23.0957 11.1893 23.0027 11.2837C22.9096 11.3781 22.8363 11.49 22.7869 11.613C22.7375 11.7359 22.713 11.8675 22.7148 12C22.7148 17.5345 18.2494 22 12.7148 22C7.18031 22 2.71484 17.5345 2.71484 12C2.71484 6.46547 7.18031 2 12.7148 2C15.2268 2 17.5053 2.93102 19.2598 4.45508L16.7148 7H22.7148V1L20.6758 3.03906C18.5553 1.15537 15.7687 0 12.7148 0ZM15.4023 8.34961C13.5863 8.34961 12.4434 9.71092 12.4434 12.0449C12.4434 14.3789 13.5703 15.7744 15.4023 15.7754C17.2283 15.7754 18.3613 14.3748 18.3613 12.0508C18.3613 9.70678 17.2143 8.34961 15.4023 8.34961ZM8.84961 8.53906L7.05859 9.75977V11.3027L8.75781 10.1543H8.84961V15.5859H10.6426V8.53906H8.84961ZM15.4023 9.72656C16.0863 9.72656 16.5449 10.4969 16.5449 12.0449C16.5449 13.6029 16.0863 14.3984 15.4023 14.3984C14.7183 14.3984 14.2637 13.6029 14.2637 12.0449C14.2637 10.4969 14.7183 9.72656 15.4023 9.72656Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default Forward10Icon;
